import { create } from 'zustand';

const useServicesStore = create((set) => ({
  services: [],
  total: 0,
  addService: (newService) =>
    set((state) => ({ services: [...state.services, newService] })),
  removeService: (serviceId) =>
    set((state) => ({
      services: state.services.filter(
        (service) => service.serviceId !== serviceId
      ),
    })),
  calculateTotal: () =>
    set((state) => ({
      total: state.services.reduce(
        (acc, { quantity, price }) => acc + price * quantity,
        0
      ),
    })),
  clearService: () =>
    set(() => ({
      services: [],
    })),
}));

export default useServicesStore;
